import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import ListHeader from '../../components/list/ListHeader';
import MassUpdatePopup from '../../components/list/MassUpdatePopup';
import TableUI from '../../components/list/TableUI';
import FilterPannel from '../../components/filter/FilterPannel';
import HeaderViewList from '../list/HeaderViewList';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import PropertyAPI from '../../api/PropertyAPI';
import Util from '../../util/Util';
import KeyValueAPI from '../../api/KeyValueAPI';
import Display from '../../util/Display';
import ImportExportAPI from '../../api/ImportExportAPI';
import ViewController from '../../controller/ViewController';

class PropertyList extends React.Component {

  constructor(props) {
    super(props);

    const user = parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id);
    this.User = Const.Opt + user + Const.Opt;

    const query = new URLSearchParams(props.location.search);
    let filters = query.get('filters') ? JSON.parse(query.get('filters')) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.property;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Property);
    this.view = this.views.find((view) => view.id === (filters ? 0 : cView.property ? cView.property : 0));
    if(!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }
    if(!filters) {
      const list = reactLocalStorage.getObject(Const.ListProperty);
      filters = list && list.filters ? list.filters : filters;
    }
    this.setList(filters);

    this.data = { properties: [], count: 0 };
    this.state = { massUpdate: false, massDelete: false, inApiCall: true, isFilterOpen: this.list.isFilterOpen };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    this.selected = [];
  }

  componentDidMount() { 
    if(this.List) {
      this.loadProprties(); 
    }
  }

  setList = filters => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.property;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, property: lists };
    }

    const fields = ['property_id', 'name', 'phone', 'email', 'responsible_person'];
    this.list = lists.find(list => list.view === this.view.id);


    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, property: [...modelfields.property, this.list] };
    }

    this.list.fields = this.view.fields && this.view.fields.length > 0 && this.view.fields[0] ? this.view.fields 
      : this.list.fields ? this.list.fields : fields;
    this.list.filters = filters ? filters : this.list.filters ? this.list.filters : [];

    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage ? this.list.pagination.currentPage : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount ? this.list.pagination.currentPage : 1;
    this.list.pagination.perPage = this.list.pagination.perPage ? this.list.pagination.perPage : 10;

    this.list.sorting = this.list.sorting ? this.list.sorting : { };
    this.list.sorting.field = this.view.sortField ? this.view.sortField : 'id';
    this.list.sorting.order = this.view.sortOrder ? this.view.sortOrder : -1; 

    if(this.ListRestrict) {
      this.list.fields = this.view && this.view.fields && this.view.fields.length > 0 ?  this.view.fields : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if(!field) {
        return false;
      }
      
      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  }

  saveListFields = fields => {
    let tmpField = reactLocalStorage.getObject(Const.FieldList);
    if (tmpField.property) {
      const tmp = tmpField.property.find((item) => item.view === this.view.id);
      if (tmp) {
        tmp.fields = fields;
      } else {
        tmpField = { ...tmpField, property: [...tmpField.property, { view: this.view.id, fields }] };
      }
    } else {
      tmpField = { ...tmpField, property: [{ view: this.view.id, fields }] };
    }
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  };

  saveListSort = sorting => {
    let tmpField = reactLocalStorage.getObject(Const.FieldList);
    if (tmpField.property) {
      const tmp = tmpField.property.find((item) => item.view === this.view.id);
      if (tmp) {
        tmp.sorting = sorting;
      } else {
        tmpField = { ...tmpField, property: [...tmpField.property, { view: this.view.id, sorting }] };
      }
    } else {
      tmpField = { ...tmpField, property: [{ view: this.view.id, sorting }] };
    }
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  }
  
  loadProprties = () => {
    reactLocalStorage.setObject(Const.ListProperty, this.list);
    const mainFilters = ViewController.getRestrictionsView(Const.Property);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true });
    PropertyAPI.list({ ...this.list, filters }, this.onReceived, this.props.failure, this.props.logout);
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = res => {
    this.data.properties = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  }

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.savePageChange(currentPage);
    this.loadProprties();
  }

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.savePerPage(perPage);
    this.loadProprties();
  }

  onFieldSelection = fields => {
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadProprties();
  }

  savePerPage = perPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.property.find((item) => item.view === this.view.id);
    tmp.pagination.perPage = perPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => {});
  }

  savePageChange = currentPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.property.find((item) => item.view === this.view.id);
    tmp.pagination.currentPage = currentPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  }

  showMassUpdate = () => {
    if (this.list.filters.length === 0 && this.selected.length === 0) {
      Util.showNotification('Failure', 'Please apply filters or Select Data', 'danger');
    } else this.setState({ ...this.state, massUpdate: !this.state.massUpdate });
  }

  hideMassUpdate = () => this.setState({ ...this.state, massUpdate: false });

  showMassDelete = () => {
    if (this.list.filters.length === 0 && this.selected.length === 0) {
      Util.showNotification('Failure', 'Please select leads', 'danger');
    } else {
      Util.confirmAlert('Delete', `Are you sure you want to mass delete (${this.selected.length}) properties ?`,
        'Mass Delete', 'No', () => {
          this.setState({ ...this.state, inApiCall: true });
          PropertyAPI.massDelete(this.list, this.selected, this.onMassDeleted, this.onFail);
        });
    }
  }

  hideMassDelete = () => this.setState({ ...this.state, massDelete: false });

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListProperty, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  }
  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => { this.list.filters = filters; this.loadProprties(); }

  onAddEdit = indx => this.props.navigate(`${this.props.match.path}/add-edit/`
    + `${indx !== -1 ? this.data.properties[indx].id : 0}`);
  onPreview = indx => this.props.navigate(`${this.props.match.path}/preview/`
    + `${this.data.properties[indx].id}`);
  onDelete = indx => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.data.properties[indx])}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      PropertyAPI.delete(this.data.properties[indx].id, this.onDeleteSuccess,
        this.onFail, this.props.logout);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Property deleted successfully', 'success');
    this.loadProprties();
  }

  onLeads = indx => {
    const property = this.data.properties[indx];
    const filter = [];
    
    if(property.price) {
      filter.push({ field: 'min_budget', type: 'decimal', 
        condition: 'start-with', value: `${property.price}~` });
      filter.push({ field: 'max_budget', type: 'decimal', 
        condition: 'end-with', value: `~${property.price}` });
    }

    if(property.property_transaction) filter.push({ field: 'property_transaction', type: 'select', 
      condition: 'in', value: `~${property.property_transaction}~` });

    if(property.property_type) filter.push({ field: 'property_type', type: 'select', 
      condition: 'in', value: `~${property.property_type}~` });
    
    this.props.navigate(`/lead?filters=${JSON.stringify(filter)}`);
  }

  import = () => this.props.navigate(`/setting/import/add?model=${Const.Property}`);
  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    +` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      const filters = ViewController.filters( [...this.list.filters], this.view.filters, this.Restrict);
      ImportExportAPI.exportModel(Const.Property, filters, this.list.sorting, this.data.count, fields, this.model.model_no,
        this.onExport, this.onFail);
  });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Property Exported in progress.'
      + ' Please visit Settings', 'success');
  }

  onMassUpdate = updates => {
    this.setState({ ...this.state, massUpdate: false, inApiCall: true });
    PropertyAPI.massUpdate(this.list, this.selected, updates, this.onMassUpdated, this.onFail);
  }
  onMassUpdated = () => {
    Util.showNotification('Successful', 'Property Mass Updated successfull.', 'success');
    this.selected = [];
    this.setState({ ...this.state, selected: !this.state.selected });
    this.loadProprties();
  }

  onMassDeleted = () => {
    Util.showNotification('Successful', 'Property Mass Deleted successfull.', 'success');
    this.loadProprties();
  }

  onTabClick = view => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.property = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadProprties();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  onSelect = id => {
    this.selected.push(id);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemove = id => {
    this.selected = this.selected.filter(item => id !== item);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onSelectAll = () => {
    for (let i = 0; i < this.data.properties.length; i++) {
      const id = this.selected.find(item => item === this.data.properties[i].id);
      if (!id) this.selected.push(this.data.properties[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemoveAll = () => {
    for (let i = 0; i < this.data.properties.length; i++) {
      this.selected = this.selected.filter(item => item !== this.data.properties[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };

  render() {
    if(!this.List) return null;
    return (
      <div>
        { this.state.massUpdate &&
          <MassUpdatePopup models={this.model} onUpdateChanged={this.onUpdateChanged}
            onMassUpdate={this.onMassUpdate} showMassUpdate={this.showMassUpdate} />
        }

        <HeaderViewList
          views={this.views}
          view={this.view}
          onTabClick={this.onTabClick}
        />

        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.count}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(-1)}
          add={this.Add}
          import={this.import}
          export={this.export}
          update={this.update}
          showMassUpdate={this.showMassUpdate}
          showMassDelete={this.showMassDelete}
        />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.properties}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              preview={true}
              update={this.Update}
              delete={this.Delete}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              onFieldSelection={this.onFieldSelection}
              onOrderChange={this.onOrderChange}
              isFilterOpen={this.state.isFilterOpen}
              findLeads={this.onLeads}
              selected={this.selected} onSelect={this.onSelect} onRemove={this.onRemove}
              onSelectAll={this.onSelectAll} onRemoveAll={this.onRemoveAll}
            />

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
              closeFilter={this.closeFilter}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(PropertyList);